<div class="se-header-toolbar-row">
    <div class="logo-container">
        <img src="assets/images/se-logo-red-white.svg" (click)="onLogoClick()" alt="image" />
    </div>

    <div class="spacer"></div>

    <!--  Componente per la gestione delle informazioni passate all'apertura della pagina (paziente, esame....) -->
    <se-header-info *ngIf="!!info1" style="display:flex" [info]="info1"></se-header-info>

    <div class="spacer"></div>

    <!--  Componente per la gestione delle informazioni passate all'apertura della pagina (paziente, esame....) -->
    <se-header-info *ngIf="!!info2" style="display:flex" [info]="info2"></se-header-info>

    <div class="spacer"></div>

    <!--  Componente per la gestione delle notifiche -->
    <se-header-notification></se-header-notification>

    <mat-divider vertical class="se-header-divider"></mat-divider>

    <!-- Componente per la gestione delle options (eg: temi chiaro\scuro) -->
    <se-header-options></se-header-options>

    <!-- Componente per la gestione della connettività (eg: IsIntegration / eXtensa) -->
    <se-header-connectivity></se-header-connectivity>

    <!-- About o help contestuale della pagina -->
    <se-header-about></se-header-about>

    <mat-divider vertical class="se-header-divider se-header-divider-last"></mat-divider>

    <!--  Componente per la gestione delle info utente -->
    <se-header-user-info></se-header-user-info>
</div>
